<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <center v-if="load">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <b-row v-else>
        <b-col
          cols="12"
          class="p-1"
        >
          <b-form
            class="chat-app-form"
            @submit.prevent="submitEmployee"
          >
            <validation-observer
              ref="employeeForm"
              class="w-100"
            >
              <b-row>
                <b-col
                  md="3"
                  sm="4"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="full_name"
                    vid="full_name"
                    rules="required"
                  >
                    <b-form-group
                      label="الاسم *"
                      label-for="full_name"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <b-form-input
                          v-model="employee.full_name"
                          placeholder="الاسم"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="3"
                  sm="4"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="nack_name"
                    vid="nack_name"
                    rules="required"
                  >
                    <b-form-group
                      label="أسم الشهرة"
                      label-for="nack_name"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <b-form-input
                          v-model="employee.nack_name"
                          placeholder="أسم الشهرة"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="3"
                  sm="4"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="national_id"
                    vid="national_id"
                    rules="required|national_id"
                  >
                    <b-form-group
                      label="الرقم القومي *"
                      label-for="national_id"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <b-form-input
                          v-model="employee.national_id"
                          placeholder="الرقم القومي"
                          maxlength="14"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="2"
                  sm="3"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="phone"
                    vid="phone"
                  >
                    <b-form-group
                      label="تاريخ بدا التدريب"
                      label-for="phone"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <flat-pickr
                          id="training_start_date"
                          v-model="employee.training_start_date"
                          class="form-control "
                          placeholder="تاريخ بدا التدريب"
                          :config="{ dateFormat: 'Y-m-d'}"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>

                <b-col
                  md="2"
                  sm="3"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="contract_date"
                    vid="contract_date"
                    rules="required"
                  >
                    <b-form-group
                      label="تاريخ التعاقد"
                      label-for="contract_date"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <flat-pickr
                          id="contract_date"
                          v-model="employee.contract_date"
                          class="form-control "
                          placeholder="تاريخ التعاقد"
                          :config="{ dateFormat: 'Y-m-d'}"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="3"
                  sm="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="نوع التعاقد"
                    vid="contract type"
                    rules="required"
                  >
                    <b-form-group
                      label=" نوع التعاقد"
                      label-for="contract type"
                    >
                      <v-select
                        v-model="employee.contract_type"
                        :options="contractTypes"
                        :reduce="val => val.value"
                        :get-option-label="option => option.label_ar"
                      />
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="3"
                  sm="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="التجنيد"
                    vid="contract type"
                    rules="required"
                  >
                    <b-form-group
                      label="التجنيد"
                      label-for="contract type"
                    >
                      <v-select
                        v-model="employee.military_status"
                        :options="militaryStatusTypes"
                        :reduce="val => val.value"
                        :get-option-label="option => option.label_ar"
                      />
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>

                <b-col
                  md="3"
                  sm="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="القسم"
                    vid="department_id"
                    rules="required"
                  >
                    <b-form-group
                      label=" القسم"
                      label-for="department_id"
                    >
                      <v-select
                        v-model="employee.department_id"
                        :options="departmentsLookup"
                        :reduce="val => val.id"
                        :get-option-label="option => option.name"
                      />
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="2"
                  sm="3"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="status"
                    vid="status"
                    rules="required"
                  >
                    <b-form-group
                      label="الحالة"
                      label-for="status"
                    >
                      <v-select
                        v-model="employee.status"
                        :options="employeeStatuses"
                        :reduce="val => val.value"
                        :get-option-label="option => option.label_ar"
                      />
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="2"
                  sm="3"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="social status"
                    vid="social status"
                    rules="required"
                  >
                    <b-form-group
                      label="الحالة الاجتماعية"
                      label-for="social status"
                    >
                      <v-select
                        v-model="employee.social_status"
                        :options="employeeSocialStatuses"
                        :reduce="val => val.value"
                        :get-option-label="option => option.label_ar"
                      />
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="4"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="address"
                    vid="address"
                    rules="required"
                  >
                    <b-form-group
                      label="العنوان *"
                      label-for="address"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <b-form-input
                          v-model="employee.address"
                          placeholder="العنوان"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="3"
                  sm="4"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="المؤهلات"
                    vid="qualifications"
                    rules="required"
                  >
                    <b-form-group
                      label="المؤهلات"
                      label-for="qualifications"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <b-form-input
                          v-model="employee.qualifications"
                          placeholder="المؤهلات"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="3"
                  sm="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="الشهادات و الدورات التدريبية"
                    vid="certificates_training_courses"
                    rules="required"
                  >
                    <b-form-group
                      label=" الشهادات و الدورات التدريبية"
                      label-for="certificates_training_courses"
                    >
                      <b-input-group class="input-group-merge">
                        <b-form-textarea
                          id="certificates_training_courses"
                          v-model="employee.certificates_training_courses"
                          placeholder="الشهادات و الدورات التدريبية"
                          rows="2"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  v-for="(phone, index) in employee.phones"
                  :key="`phone-${index}`"
                  md="4"
                >

                  <b-row>
                    <b-col cols="5">
                      <validation-provider
                        #default="{ errors }"
                        :name="`phone_${index}`"
                        :vid="`phone_${index}`"
                        rules="required|phone"
                      >
                        <b-form-group
                          label="الهاتف*"
                          :label-for="`phone_${index}`"
                        >
                          <b-input-group class="input-group-merge">
                            <b-form-input
                              :id="`phone_${index}`"
                              v-model="phone.phone_number"
                              placeholder="أدخل رقم الهاتف"
                            />
                          </b-input-group>
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <b-col
                      cols="5"
                      class="pt-2"
                    >
                      <b-form-radio
                        v-model="phone.phone_type"
                        plain
                        :name="`mobile_${index}`"
                        value="mobile"
                      >
                        mobile
                      </b-form-radio>
                      <b-form-radio
                        v-model="phone.phone_type"
                        plain
                        :name="`whatsapp_${index}`"
                        value="whatsapp"
                      >
                        whatsapp
                      </b-form-radio>

                    </b-col>
                    <b-col cols="2">
                      <div class="">
                        <feather-icon
                          v-if="index != 0"
                          icon="TrashIcon"
                          class="text-danger mt-1"
                          style="cursor: pointer;"
                          size="20"
                          @click="removePhone"
                        />
                        <feather-icon
                          icon="PlusIcon"
                          class="text-primary mt-1"
                          style="cursor: pointer;"
                          size="20"
                          @click="addPhone"
                        />
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  sm="5"
                  md="3"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="الصورة الشخصية"
                    vid="file"
                    rules="required"
                  >
                    <b-form-group
                      label="الصورة الشخصية *"
                      label-for="file"
                    >
                      <b-form-file
                        v-model="employee.avatar"
                        :state="Boolean(employee.avatar)"
                        placeholder="اختر ملف"
                        drop-placeholder="اسحب الملف هنا"
                        browse-text="تصفح"
                      />
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>

                <b-col md="12">
                  <h2 class="text-primary">
                    المرفقات
                  </h2>

                  <b-row class="w-100">
                    <b-col
                      v-for="(documentData , index) in employee.documentsData"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-row>
                        <!-- Name (Optional) -->
                        <b-col
                          sm="5"
                          md="4"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="name"
                            vid="name"
                            rules="required"
                          >
                            <b-form-group
                              label="*الاسم"
                              label-for="name"
                            >
                              <b-input-group class="input-group-merge form-send-message mr-1">
                                <b-form-input
                                  v-model="documentData.name"
                                  placeholder="الاسم "
                                />
                              </b-input-group>
                            </b-form-group>
                            <small class="text-danger float-left">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                        <!-- File Upload (Required) -->
                        <b-col
                          sm="5"
                          md="4"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="file"
                            vid="file"
                            rules="required"
                          >
                            <b-form-group
                              label="الملف *"
                              label-for="file"
                            >
                              <b-form-file
                                v-model="documentData.file"
                                :state="Boolean(documentData.file)"
                                placeholder="اختر ملف"
                                drop-placeholder="اسحب الملف هنا"
                                browse-text="تصفح"
                              />
                            </b-form-group>
                            <small class="text-danger float-left">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col cols="2">
                          <div class="">
                            <feather-icon
                              v-if="index != 0"
                              icon="TrashIcon"
                              class="text-danger mt-1"
                              style="cursor: pointer;"
                              size="20"
                              @click="removeDocument(index)"
                            />
                            <feather-icon
                              icon="PlusIcon"
                              class="text-primary mt-1"
                              style="cursor: pointer;"
                              size="20"
                              @click="addDocument"
                            />
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>

                  </b-row>

                </b-col>
                <div>
                  <h2 class="text-primary">
                    بيانات الاقارب
                  </h2>
                  <b-col
                    v-for="(emergency_contact, index) in employee.emergency_contacts"
                    :key="index"
                    md="12"
                  >
                    <b-row>
                      <b-col
                        md="4"
                        class="mb-2"
                      >
                        <validation-provider
                          #default="{ errors }"
                          :name="`emergency_contact${index}`.contact_name"
                          :vid="`emergency_contact${index}`.contact_name"
                          rules="required"
                        >
                          <b-form-group
                            label="الاسم *"
                            :label-for="`emergency_contact_${index}`.contact_name"
                          >
                            <b-input-group class="input-group-merge form-send-message mr-1">
                              <b-form-input
                                v-model="emergency_contact.contact_name"
                                placeholder="الاسم"
                              />
                            </b-input-group>
                          </b-form-group>
                          <small class="text-danger float-left">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col
                        md="3"
                        class="mb-2"
                      >
                        <validation-provider
                          #default="{ errors }"
                          :name="`emergency_contact${index}`.relationship"
                          :vid="`emergency_contact${index}`.relationship"
                          rules="required"
                        >
                          <b-form-group
                            label="الصلة *"
                            :label-for="`emergency_contact_${index}`.relationship"
                          >
                            <b-input-group class="input-group-merge form-send-message mr-1">
                              <b-form-input
                                v-model="emergency_contact.relationship"
                                placeholder="الصلة"
                              />
                            </b-input-group>
                          </b-form-group>
                          <small class="text-danger float-left">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>
                      <b-col cols="3">
                        <validation-provider
                          #default="{ errors }"
                          :name="`emergency_contact${index}`.phone_number"
                          :vid="`emergency_contact${index}`.phone_number"
                          rules="required|phone"
                        >
                          <b-form-group
                            label="هاتف الطوارئ*"
                            :label-for="`emergency_contact_${index}`.phone_number"
                          >
                            <b-input-group class="input-group-merge">
                              <b-form-input
                                :id="`emergency_contact_${index}`"
                                v-model="emergency_contact.phone_number"
                                placeholder="هاتف الطوارئ"
                              />
                            </b-input-group>
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-col>

                      <b-col cols="2">
                        <div>
                          <feather-icon
                            v-if="index != 0"
                            icon="TrashIcon"
                            class="text-danger mt-1"
                            style="cursor: pointer;"
                            size="20"
                            @click="removeEmergency_contact"
                          />
                          <feather-icon
                            icon="PlusIcon"
                            class="text-primary mt-1"
                            style="cursor: pointer;"
                            size="20"
                            @click="addEmergency_contact"
                          />
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </div>
                <b-col cols="12">
                  <b-row>
                    <h2 class="text-primary ml-2">
                      بيانات المرتب
                    </h2>
                    <b-col cols="12">
                      <b-row>

                        <b-col
                          md="4"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="basic_salary"
                            vid="basic_salary"
                            rules="required"
                          >
                            <b-form-group
                              label="المرتب *"
                              label-for="basic_salary"
                            >
                              <b-input-group class="input-group-merge form-send-message mr-1">
                                <b-form-input
                                  v-model="employee.salary_info.basic_salary"
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  placeholder="المرتب"
                                />
                              </b-input-group>
                            </b-form-group>
                            <small class="text-danger float-left">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col md="4">
                          <validation-provider
                            #default="{ errors }"
                            name="payment_method"
                            vid="payment_method"
                            rules="required"
                          >
                            <b-form-group
                              label="نوع الدفع"
                              label-for="payment_method"
                            >
                              <v-select
                                v-model="employee.salary_info.payment_method"
                                :options="salaryPaymentMethods"
                                :reduce="val => val.value"
                                :get-option-label="option => option.label_ar"
                              />
                            </b-form-group>
                            <small class="text-danger float-left">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col cols="4">
                          <validation-provider
                            #default="{ errors }"
                            name="account_number"
                            vid="account_number"
                            rules="required"
                          >
                            <b-form-group
                              label="رقم الحساب*"
                              label-for="account_number"
                            >
                              <b-input-group class="input-group-merge">
                                <b-form-input
                                  id="account_number"
                                  v-model="employee.salary_info.account_number"
                                  placeholder="أدخل رقم الحساب"
                                />
                              </b-input-group>
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col cols="6">
                          <validation-provider
                            #default="{ errors }"
                            name="notes"
                            vid="notes"
                            rules="required"
                          >
                            <b-form-group
                              label=" ملاحظات"
                              label-for="notes"
                            >
                              <b-input-group class="input-group-merge">
                                <b-form-textarea
                                  id="notes"
                                  v-model="employee.salary_info.notes"
                                  placeholder="ملاحظات"
                                  rows="3"
                                />
                              </b-input-group>
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col
                          v-if="employee.gl_account"
                          cols="12"
                        >
                          <div class="border rounded p-1 mb-1">
                            <small class="text-muted d-block">حساب الأستاذ</small>
                            <strong>{{ employee.gl_account.code }}</strong>
                            <span> — {{ employee.gl_account.name }}</span>
                          </div>
                        </b-col>
                        <b-col cols="12">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                            <h5 class="mb-0">
                              حسابات الصرف
                            </h5>
                            <b-button
                              size="sm"
                              variant="outline-primary"
                              @click="addPayout"
                            >
                              إضافة
                            </b-button>
                          </div>
                          <b-row
                            v-for="(row, index) in employee.payment_accounts"
                            :key="`payout-${index}`"
                            class="mb-1"
                          >
                            <b-col md="3">
                              <b-form-group label="طريقة الصرف">
                                <v-select
                                  v-model="row.method"
                                  :options="payoutMethodOptions"
                                  :reduce="val => val.value"
                                  :get-option-label="option => option.label_ar"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="3">
                              <b-form-group label="رقم الحساب">
                                <b-form-input v-model="row.account_number" />
                              </b-form-group>
                            </b-col>
                            <b-col md="2">
                              <b-form-group label="اسم البنك">
                                <b-form-input v-model="row.bank_name" />
                              </b-form-group>
                            </b-col>
                            <b-col md="2">
                              <b-form-group label="صاحب الحساب">
                                <b-form-input v-model="row.account_holder" />
                              </b-form-group>
                            </b-col>
                            <b-col md="2">
                              <b-form-group label="ملاحظات">
                                <b-form-input v-model="row.notes" />
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              class="text-right"
                            >
                              <b-button
                                size="sm"
                                variant="outline-danger"
                                @click="removePayout(index)"
                              >
                                حذف
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </validation-observer>
          </b-form>
          <div class="d-flex justify-content-end">
            <b-button
              variant="primary"
              class="rounded-pill mt-2"
              type="submit"
              @click="submitEmployee"
            >
              حفظ
            </b-button>
            <b-button
              class="rounded-pill mt-2 ml-1"
              @click="addNewUserModal = false"
            >
              الغاء
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

  </div>
</template>
<script>
import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BAvatar,
  BLink,
  VBTooltip,
  BSpinner,
  BPagination,
  BFormInput,
  BInputGroup,
  BForm,
  BFormGroup,
  BFormDatepicker,
  BFormRadio,
  BFormTextarea,
  BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, email, phone, national_id,
} from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BTable,
    flatPickr,
    BFormTextarea,
    BFormRadio,
    BFormDatepicker,
    BButton,
    BFormCheckbox,
    BCard,
    BForm,
    BRow,
    BCol,
    BBadge,
    BFormGroup,
    BAvatar,
    BInputGroup,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    vSelect,
    BLink,
    BSpinner,
    BPagination,
    BFormInput,
    FeatherIcon,
    BFormFile,
  },
  computed: {
    ...mapGetters({
      employeeStatuses: 'lookups/employeeStatuses',
      employeeSocialStatuses: 'lookups/employeeSocialStatuses',
      paymentMethods: 'lookups/paymentMethods',
      phoneTypes: 'lookups/phoneTypes',
      contractTypes: 'lookups/contractTypes',
      militaryStatusTypes: 'lookups/militaryStatusTypes',
      departmentsLookup: 'lookups/departmentsLookup',
      load: 'employees/load',
    }),
    employeeId() {
      return this.$route.params.id ? this.$route.params.id : null
    },
    salaryPaymentMethods() {
      const rows = Array.isArray(this.paymentMethods) ? this.paymentMethods.slice() : []
      if (!rows.some(row => row.value === 'etisalat_cash')) {
        rows.splice(2, 0, { value: 'etisalat_cash', label: 'Etisalat Cash', label_ar: 'اتصالات كاش' })
      }
      return rows
    },
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  data() {
    return {
      isDirty: false,
      initialFormSnapshot: null,
      payoutMethodOptions: [
        { value: 'vodafone_cash', label: 'Vodafone Cash', label_ar: 'فودافون كاش' },
        { value: 'etisalat_cash', label: 'Etisalat Cash', label_ar: 'اتصالات كاش' },
        { value: 'bank_transfer', label: 'Bank Transfer', label_ar: 'تحويل بنكي' },
        { value: 'instapay', label: 'InstaPay', label_ar: 'انستاباي' },
      ],
      employee: {
        full_name: null,
        nack_name: null,
        address: null,
        qualifications: null,
        avatar: null,
        department_id: null,
        militaryStatus: null,
        certificates_training_courses: null,
        contract_type: null,
        national_id: null,
        training_start_date: null,
        contract_date: null,
        status: null,
        social_status: null,
        phones: [
          { phone_number: null, phone_type: 'mobile' },
        ],
        emergency_contacts: [
          { contact_name: null, relationship: null, phone_number: null },
        ],
        salary_info: {
          basic_salary: null,
          payment_method: null,
          account_number: null,
          effective_from_date: '2024-03-01',
          notes: null,
        },
        payment_accounts: [],
        documentsData: [
          {
            document_category_id: 1,
            file: null,
            name: '',
          },
        ],
        documentCategories: [],

      },
    }
  },
  mounted() {
    this.init()
    this.initialFormSnapshot = JSON.stringify(this.employee)
    this.$watch(

      () => this.employee,
      {
        handler: val => {
          this.isDirty = JSON.stringify(this.employee) !== this.initialFormSnapshot
        },

        deep: true,
      },
    )
  },
  methods: {
    removeDocument(index) {
      if (this.employee.documentsData.length > 1) {
        this.employee.documentsData.splice(index, 1)
      }
    },
    addDocument() {
      this.employee.documentsData.push({
        document_category_id: 1,
        file: null,
        name: '',
      })
    },
    emptyEmployee() {
      this.employee = {
        full_name: null,
        national_id: null,
        training_start_date: null,
        contract_date: null,
        status: null,
        phones: [
          { phone_number: null, phone_type: 'mobile' },
        ],
        emergency_contacts: [
          { contact_name: null, relationship: null, phone_number: null },
        ],
        salary_info: {
          basic_salary: null,
          payment_method: null,
          account_number: null,
          effective_from_date: '2024-03-01',
          notes: null,
        },
        payment_accounts: [],
      }
    },
    submitEmployee() {
      this.$refs.employeeForm.validate().then(success => {
        if (success) {
          // Build FormData for all payload
          const payouts = this.cleanPayouts()
          if (payouts === null) {
            this.$swal({
              icon: 'error',
              title: '<h4>أكمل طريقة الصرف ورقم الحساب لكل صف</h4>',
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
            })
            return
          }
          const formData = new FormData()
          const skipKeys = ['documentsData', 'payment_accounts', 'gl_account', 'gl_account_id', 'wallets', 'media', 'documents', 'user', 'department', 'current_salary_info', 'primary_address', 'primary_phone', 'created_at', 'updated_at', 'deleted_at']
          // Append all top-level employee props except documentsData
          //   Object.keys(this.employee).forEach(key => {
          //     if (key !== 'documentsData' && this.employee[key] !== null && this.employee[key] !== undefined) {
          //       // Handle nested objects like salary_info, phones, etc.
          //       if (typeof this.employee[key] === 'object' && !Array.isArray(this.employee[key])) {
          //         Object.keys(this.employee[key]).forEach(subKey => {
          //           formData.append(`${key}[${subKey}]`, this.employee[key][subKey]);
          //         });
          //       } else if(Array.isArray(this.employee[key])) {
          //         this.employee[key].forEach((item, idx) => {
          //           // Only handle phones and emergency_contacts as simple key:value
          //           if (typeof item === 'object') {
          //             Object.keys(item).forEach(arrKey => {
          //               formData.append(`${key}[${idx}][${arrKey}]`, item[arrKey]);
          //             });
          //           } else {
          //             formData.append(`${key}[]`, item);
          //           }
          //         });
          //       } else {
          //         formData.append(key, this.employee[key]);
          //       }
          //     }
          //   });
          Object.keys(this.employee).forEach(key => {
            if (!skipKeys.includes(key) && this.employee[key] !== null && this.employee[key] !== undefined) {
              // Handle File objects (like avatar) - append directly
              if (this.employee[key] instanceof File) {
                formData.append(key, this.employee[key])
              }
              // Handle nested objects like salary_info, phones, etc.
              else if (typeof this.employee[key] === 'object' && !Array.isArray(this.employee[key])) {
                Object.keys(this.employee[key]).forEach(subKey => {
                  formData.append(`${key}[${subKey}]`, this.employee[key][subKey])
                })
              } else if (Array.isArray(this.employee[key])) {
                this.employee[key].forEach((item, idx) => {
                  // Only handle phones and emergency_contacts as simple key:value
                  if (typeof item === 'object') {
                    Object.keys(item).forEach(arrKey => {
                      formData.append(`${key}[${idx}][${arrKey}]`, item[arrKey])
                    })
                  } else {
                    formData.append(`${key}[]`, item)
                  }
                })
              } else {
                formData.append(key, this.employee[key])
              }
            }
          })

          // Handle documentsData files
          if (Array.isArray(this.employee.documentsData)) {
            this.employee.documentsData.forEach((doc, idx) => {
              if (doc.file) {
                formData.append(`documentsData[${idx}][file]`, doc.file)
              }
              // Add meta-info
              formData.append(`documentsData[${idx}][name]`, doc.name || '')
              formData.append(`documentsData[${idx}][document_category_id]`, doc.document_category_id || '')
            })
          }

          if (payouts.length) {
            payouts.forEach((row, idx) => {
              Object.keys(row).forEach(field => {
                if (row[field] !== null && row[field] !== undefined && row[field] !== '') {
                  formData.append(`payment_accounts[${idx}][${field}]`, row[field])
                }
              })
            })
          }

          if (this.employee.id) {
            formData.append('id', this.employee.id)
            this.$store.dispatch('employees/update', { id: this.employee.id, query: formData }).then(res => {
              this.addNewUserModal = false
              // this.emptyEmployee()
              this.$swal({
                icon: 'success',
                title: `<h4>${res.message}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#06284D',
                allowOutsideClick: true,
              })
              this.$route.push({ name: 'employees' })
            }).catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: `<h4>${error.response.data.message}</h4>`,
                  showConfirmButton: true,
                  confirmButtonColor: '#06284D',
                  allowOutsideClick: true,
                })
              }
            })
          } else {
            this.$store.dispatch('employees/store', { query: formData }).then(res => {
              this.addNewUserModal = false
              this.emptyEmployee()
              this.$swal({
                icon: 'success',
                title: `<h4>${res.message}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#06284D',
                allowOutsideClick: true,
              })
            }).catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: `<h4>${error.response.data.message}</h4>`,
                  showConfirmButton: true,
                  confirmButtonColor: '#06284D',
                  allowOutsideClick: true,
                })
              }
            })
          }
        }
      })
    },
    addPayout() {
      this.employee.payment_accounts.push({
        method: null,
        account_number: '',
        bank_name: '',
        account_holder: '',
        notes: '',
      })
    },
    removePayout(index) {
      this.employee.payment_accounts.splice(index, 1)
    },
    cleanPayouts() {
      const rows = this.employee.payment_accounts || []
      const complete = []
      for (let i = 0; i < rows.length; i += 1) {
        const row = rows[i]
        const method = row.method
        const accountNumber = String(row.account_number || '').trim()
        const touched = method || accountNumber || row.bank_name || row.account_holder || row.notes
        if (!touched) continue
        if (!method || !accountNumber) return null
        complete.push({
          method,
          account_number: accountNumber,
          bank_name: row.bank_name || null,
          account_holder: row.account_holder || null,
          notes: row.notes || null,
        })
      }
      return complete
    },
    addEmergency_contact() {
      this.employee.emergency_contacts.push(
        { contact_name: null, relationship: null, phone_number: null },
      )
    },
    removeEmergency_contact(index) {
      if (this.employee.emergency_contacts.length > 1) {
        this.employee.emergency_contacts.splice(index, 1)
      }
    },
    addPhone() {
      this.employee.phones.push({
        phone_number: null,
        phone_type: 'mobile',
      })
    },
    removePhone(index) {
      if (this.employee.phones.length > 1) {
        this.employee.phones.splice(index, 1)
      }
    },
    init() {
      this.$store.dispatch('lookups/employeeStatuses')
      this.$store.dispatch('lookups/employeeSocialStatuses')
      this.$store.dispatch('lookups/contractTypes')
      this.$store.dispatch('lookups/militaryStatusTypes')
      this.$store.dispatch('lookups/departmentsLookup')
      this.$store.dispatch('lookups/paymentMethods')
      this.$store.dispatch('lookups/phoneTypes')
      if (this.employeeId) {
        this.$store.dispatch('employees/show', { id: this.employeeId }).then(res => {
          const data = res.data || {}
          this.employee = data
          const salary = Array.isArray(data.salary_info) ? data.salary_info[0] : data.salary_info
          this.employee.salary_info = salary || {
            basic_salary: null,
            payment_method: null,
            account_number: null,
            effective_from_date: '2024-03-01',
            notes: null,
          }
          this.employee.payment_accounts = (data.payment_accounts || [])
            .filter(row => row.is_active !== false)
            .map(row => ({
              method: row.method,
              account_number: row.account_number || '',
              bank_name: row.bank_name || '',
              account_holder: row.account_holder || '',
              notes: row.notes || '',
            }))
        })
      }
    },

  },
  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      if (confirm('لقد قمت بتعديل بيانات لم تحفظها. إذا خرجت ستفقد هذه البيانات. هل أنت متأكد من رغبتك في المغادرة؟')) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
 .input-group .form-control{
    background-color: #fff !important;
 }
</style>
